import Base from '@studiometa/js-toolkit';
import { fbShare, tw } from 'vanilla-sharing';

// The Facebook app id is required to share a link
import { fbAppId } from '../config';

const WIN_PARAMS =
  'scrollbars=0, resizable=1, menubar=0, left=100, top=100, width=550, height=440, toolbar=0, status=0';

/**
 * Share class.
 */
export default class Share extends Base {
  /**
   * Class cofnig
   * @return {Object}
   */
  static config = {
    name: 'Share',
    refs: ['linkedin', 'twitter', 'facebook'],
  };

  url = window.location.href;

  /**
   *
   *
   * @memberof Share
   */
  onLinkedinClick() {
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${this.url}&mini=true`,
      '_blank',
      WIN_PARAMS
    );
  }

  /**
   *
   *
   * @memberof Share
   */
  onTwitterClick() {
    tw({
      url: this.url,
    });
  }

  /**
   *
   *
   * @memberof Share
   */
  onFacebookClick() {
    fbShare({
      url: this.url,
      fbAppId,
    });
  }
}
